import { render, staticRenderFns } from "./FeeUnitBlock.vue?vue&type=template&id=1a97aae2&"
import script from "./FeeUnitBlock.vue?vue&type=script&lang=js&"
export * from "./FeeUnitBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports